module.exports = __webpack_public_path__ + "static/media/copan.84456ef4.png";